module.exports = __webpack_public_path__ + "img/case1-7.c3427495.jpg";